import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApkLoanKTAFinancial2Service from "services/Setup/LoanOrigination/Financial/ApkLoanKTAFinancial2Service";
import { notification } from "antd";
import { resetDataFinancial1 } from "./ApkLoanKTAFinancial1Slice";
import editData from "assets/data/sempelresponeditkkb/financial2.json"

export const initialState = {
  loading: false,
  loadingFinancial2: false,
  loadingConvertEffectiveToFlat: false,
  loadingConvertFlatToEffective: false,
  loadingTotalInterest: false,
  loadingMonthlyInstallment: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  flatToEffective: [],
  effectiveToFlat: [],
  InsuranceComBranchList: [],
  getApkLoanKTAFinancial2: [],
  // getEditApkLoanKTAFinancial2: editData?.data || [],
  getEditApkLoanKTAFinancial2: [],
  totalInterest: {},
  monthlyInstallment: {},
  simulateWithInstallment: [],
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const getApkLoanKTAFinancial2Slice = createAsyncThunk(
  "ApkLoanKTAFinancial2/getApkLoanKTAFinancial2Slice",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getApkLoanKTAFinancial2Slice ~ userInput", userInput);
    try {
      const response =
        await ApkLoanKTAFinancial2Service.getApkLoanKTAFinancial2Service(
          userInput
        );
      console.log("🚀 ~ getApkLoanKTAFinancial2Slice ~ response", response);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getEditApkLoanKTAFinancial2Slice = createAsyncThunk(
  "ApkLoanKTAFinancial2/getEditApkLoanKTAFinancial2Slice",
  async (userInput, { rejectWithValue }) => { 
    try {
      const response =
        await ApkLoanKTAFinancial2Service.getEditApkLoanKTAFinancial2Service(
          userInput
        ); 

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postApkLoanKTAFinancial2Slice = createAsyncThunk(
  "ApkLoanKTAFinancial2/postApkLoanKTAFinancial2Slice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKTAFinancial2Service.postApkLoanKTAFinancial2Service(
          userInput
        );
      console.log("responsepostApkLoanKTAFinancial2Service", response);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putApkLoanKTAFinancial2Slice = createAsyncThunk(
  "ApkLoanKTAFinancial2/putApkLoanKTAFinancial2Slice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKTAFinancial2Service.putApkLoanKTAFinancial2Service(
          userInput
        );
      console.log("responseputApkLoanKTAFinancial2Service", response);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const ApkLoanKTAFinancial2Slice = createSlice({
  name: "apkLoanKTAFinancial2",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },

    resetDataFinancial2: (state) => {
      state.getEditApkLoanKTAFinancial2 = [];
      state.getApkLoanKTAFinancial2 = [];
    },
  },

  extraReducers: (builder) => {
    builder

      // getApkLoanKTAFinancial2Slice
      .addCase(getApkLoanKTAFinancial2Slice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getApkLoanKTAFinancial2Slice.fulfilled, (state, action) => {
        console.log("🚀 ~ getApkLoanKTAFinancial2Slice ~ action", action);

        state.loading = false;
        state.getApkLoanKTAFinancial2 = action?.payload?.data;
      })
      .addCase(getApkLoanKTAFinancial2Slice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // getEditApkLoanKTAFinancial2Slice
      .addCase(getEditApkLoanKTAFinancial2Slice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getEditApkLoanKTAFinancial2Slice.fulfilled, (state, action) => {
        state.loading = false;
        state.getEditApkLoanKTAFinancial2 = action?.payload?.data;
      })
      .addCase(getEditApkLoanKTAFinancial2Slice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //   pos
      .addCase(postApkLoanKTAFinancial2Slice.pending, (state) => {
        state.loadingFinancial2 = true;
      })
      .addCase(postApkLoanKTAFinancial2Slice.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loadingFinancial2 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(postApkLoanKTAFinancial2Slice.rejected, (state, action) => {
        state.loadingFinancial2 = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   pos
      .addCase(putApkLoanKTAFinancial2Slice.pending, (state) => {
        state.loadingFinancial2 = true;
      })
      .addCase(putApkLoanKTAFinancial2Slice.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loadingFinancial2 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(putApkLoanKTAFinancial2Slice.rejected, (state, action) => {
        state.loadingFinancial2 = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
  resetDataFinancial2,
} = ApkLoanKTAFinancial2Slice.actions;

export default ApkLoanKTAFinancial2Slice.reducer;
